// extracted by mini-css-extract-plugin
export default {"successful-change-password":"change-password_successful-change-password__gHhRn","successful-change-password__text":"change-password_successful-change-password__text__5Pcht"};